import React, { useState, useEffect, useRef } from 'react'
import './CompetitionEnrollModal.css'

const COMPETITION_END = new Date('2026-05-22T22:00:00Z')

const PRIZES = [
  { id: 'ti84', name: 'TI-84 Plus CE Graphing Calculator', imageUrl: '/prizes/ti84.jpg' },
  { id: 'fortnite', name: '$15 Fortnite Virtual Gift Card', imageUrl: '/prizes/fortnite.png' },
  { id: 'plushie', name: 'BFDI "4" Plushie', imageUrl: '/prizes/plushie.jpg' }
]

function formatDate(date) {
  return date.toLocaleDateString('en-US', {
    month: 'long', day: 'numeric', year: 'numeric',
    hour: 'numeric', minute: '2-digit', timeZoneName: 'short',
    timeZone: 'America/New_York'
  })
}

const CompetitionEnrollModal = ({ students, enrolledIds, onEnroll, onDismiss }) => {
  const hasNoStudents = students.length === 0
  const unenrolledStudents = students.filter(s => !enrolledIds.has(s.id))
  const [selected, setSelected] = useState(() => new Set(unenrolledStudents.map(s => s.id)))
  const [enrolling, setEnrolling] = useState(false)
  const mountedRef = useRef(true)
  useEffect(() => { return () => { mountedRef.current = false } }, [])

  const toggleStudent = (id) => {
    setSelected(prev => {
      const next = new Set(prev)
      if (next.has(id)) next.delete(id)
      else next.add(id)
      return next
    })
  }

  const handleEnroll = async () => {
    if (selected.size === 0) return
    setEnrolling(true)
    try {
      await onEnroll([...selected])
    } finally {
      if (mountedRef.current) setEnrolling(false)
    }
  }

  return (
    <div className="comp-enroll-overlay">
      <div className="comp-enroll-modal">
        <div className="comp-enroll-header">
          <div className="comp-enroll-trophy">🏆</div>
          <h2 className="comp-enroll-title">XP Competition</h2>
          <p className="comp-enroll-subtitle">
            The top 3 students win a prize! Competition ends{' '}
            <strong>{formatDate(COMPETITION_END)}</strong>.
          </p>
        </div>

        <div className="comp-enroll-prizes">
          {PRIZES.map(prize => (
            <div key={prize.id} className="comp-enroll-prize-card">
              <img src={prize.imageUrl} alt={prize.name} className="comp-enroll-prize-img" />
              <div className="comp-enroll-prize-name">{prize.name}</div>
            </div>
          ))}
        </div>

        <div className="comp-enroll-how">
          <p>Students earn XP by answering questions correctly. 1st place gets first choice in these prizes! 2nd place gets second choice!</p>
        </div>

        {hasNoStudents ? (
          <div className="comp-enroll-all-enrolled">
            <p>Once you add students to your account, you can enter them in the competition!</p>
            <button className="comp-enroll-btn-primary" onClick={onDismiss}>Got it!</button>
          </div>
        ) : unenrolledStudents.length > 0 ? (
          <>
            <div className="comp-enroll-students-label">Select students to enter:</div>
            <div className="comp-enroll-students-list">
              {unenrolledStudents.map(s => (
                <label key={s.id} className="comp-enroll-student-row">
                  <input
                    type="checkbox"
                    checked={selected.has(s.id)}
                    onChange={() => toggleStudent(s.id)}
                    className="comp-enroll-checkbox"
                  />
                  <span className="comp-enroll-student-name">{s.firstName} {s.lastName}</span>
                </label>
              ))}
            </div>

            <div className="comp-enroll-actions">
              <button
                className="comp-enroll-btn-primary"
                onClick={handleEnroll}
                disabled={selected.size === 0 || enrolling}
              >
                {enrolling ? 'Enrolling...' : `Enroll Selected Student${selected.size !== 1 ? 's' : ''}`}
              </button>
              <button className="comp-enroll-btn-secondary" onClick={onDismiss}>
                Maybe Later
              </button>
            </div>
          </>
        ) : (
          <div className="comp-enroll-all-enrolled">
            <p>All your students are already enrolled! Good luck! 🎉</p>
            <button className="comp-enroll-btn-primary" onClick={onDismiss}>Got it!</button>
          </div>
        )}
      </div>
    </div>
  )
}

export default CompetitionEnrollModal
export { COMPETITION_END, PRIZES }
